import { getLocationParamSearch } from '@/helpers';
import { history } from '@/shared/utils/history';

export default function useRouter() {
  const { sessionId, activityId, status } = getLocationParamSearch(history);

  return { sessionId, activityId, status, history, pathname: history.pathname };
}
